module.exports = __webpack_public_path__ + "static/media/comingsoon.0958ef15.png";